import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataConditionSheet } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_CONDITION_SHEET =
  defineMasterdataEntity<MasterdataConditionSheet>({
    name: 'condition-sheet',
    responseKey: 'conditionSheets',
    displayWith: (c) => keyName(c.key, c.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-file-contract',
    title: 'Konditionsblattsuche',
    label: 'Konditionsblatt',
    placeholder: 'Konditionsblatt suchen...',
    columns: [
      {
        label: 'Konditionsblatt',
        type: 'entity',
        icon: 'fa-regular fa-file-contract',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
    ],
  });
